import { projectFeaturesData, projectTypesData } from "config";
import { FormData } from "./CreateProjectSheet.types";

// Get feature data by name
export const getFeatureData = (featureName: string) => {
  return projectFeaturesData.find((f) => f.name === featureName);
};

// Get feature key for form control
export const getFeatureKey = (featureName: string) => {
  const keyMap: { [key: string]: keyof FormData["features"] } = {
    "Coverage": "has_coverage",
    "Character breakdown": "has_character_breakdown",
    "Script breakdown": "has_script_breakdown",
    "Budget": "has_budget",
    "Schedule": "has_schedule",
  };
  return keyMap[featureName] || "has_coverage";
};

const PROJECT_NAME_MAX_LENGTH = 165;

/** "THE KEEPER" reads as a shout in a name field; title-case text typed in all caps. */
const toTitleCaseIfShouting = (text: string) =>
  /[a-z]/.test(text) ? text : text.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

/**
 * A project name from an imported screenplay: its title page title, else the
 * file name without extension and separators. Empty when neither is usable.
 */
export const suggestProjectName = (title: unknown, fileName?: string | null): string => {
  const fromTitle = typeof title === "string" ? title.replace(/\s+/g, " ").trim() : "";
  const fromFile = (fileName ?? "")
    .replace(/\.[^.]+$/, "")
    .replace(/[_.]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const name = fromTitle || fromFile;
  return toTitleCaseIfShouting(name).slice(0, PROJECT_NAME_MAX_LENGTH).trim();
};

// Convert project types to dropdown options
export const getProductionTypeOptions = () => {
  if (!projectTypesData || !Array.isArray(projectTypesData)) {
    console.warn("projectTypesData is not available or not an array:", projectTypesData);
    return [];
  }

  return projectTypesData
    .filter((type) => type.active)
    .map((type) => ({
      value: type.key,
      label: type.name,
    }));
};
